import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles({
  compoundButton: { maxWidth: 50, padding: 6 },
  compoundLeft: {
    position: "relative",
    left: 9,
  },
  compoundRight: {
    position: "relative",
    left: -9,
  },
  button: {
    padding: 6,
  },
});

type PagerControlsProps = {
  navigate: (newParams: { [key: string]: any }) => void;
  page: number;
  totalPages: number;
  hasData: boolean;
  showFirstLastButtons?: boolean;
};

export const ResponsePagerControls: React.FC<PagerControlsProps> = ({
  navigate,
  page,
  totalPages,
  hasData,
  showFirstLastButtons = true,
}) => {
  const classes = useStyles();

  return (
    <>
      {showFirstLastButtons ? (
        <Tooltip title="First Page">
          <span>
            <IconButton
              onClick={(_) => navigate({ page: undefined })}
              disabled={!hasData || page === 0}
              data-test="pager-first"
              className={classes.compoundButton}
              title="First page"
            >
              <ChevronLeft className={classes.compoundLeft} />
              <ChevronLeft className={classes.compoundRight} />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
      <Tooltip title="Previous Page">
        <span>
          <IconButton
            // if page = 0 then just send undefined to just remove the page param
            onClick={(_) => navigate({ page: page - 1 || undefined })}
            disabled={!hasData || page === 0}
            data-test="pager-prev"
            className={classes.button}
            title="Previous page"
          >
            <ChevronLeft />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Next Page">
        <span>
          <IconButton
            onClick={(_) => navigate({ page: page + 1 })}
            disabled={!hasData || totalPages === 0 || page === totalPages - 1}
            data-test="pager-next"
            className={classes.button}
            title="Next page"
          >
            <ChevronRight />
          </IconButton>
        </span>
      </Tooltip>
      {showFirstLastButtons ? (
        <Tooltip title="Last Page">
          <span>
            <IconButton
              onClick={(_) => navigate({ page: totalPages - 1 })}
              disabled={!hasData || totalPages === 0 || page === totalPages - 1}
              data-test="pager-last"
              className={classes.compoundButton}
              title="Last page"
            >
              <ChevronRight className={classes.compoundLeft} />
              <ChevronRight className={classes.compoundRight} />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
    </>
  );
};
